import { Routes } from '@angular/router';
import { adminAuthGuard } from './core/auth/admin-auth.guard';
import { AdminLoginComponent } from './components/auth/admin-login/admin-login';
import { AdminRegisterComponent } from './components/auth/admin-register/admin-register';
import { AllCitiesComponent } from './components/cities/all-cities/all-cities.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AdminProfileComponent } from './components/profile/admin-profile/admin-profile';

export const routes: Routes = [
  {
    path: 'login',
    component: AdminLoginComponent,
  },
  {
    path: 'register',
    component: AdminRegisterComponent,
  },
  {
    path: 'dashboard',
    canActivate: [adminAuthGuard],
    component: DashboardComponent,
  },
  {
    path: 'property',
    canActivate: [adminAuthGuard],
    loadChildren: () =>
      import('./components/property/property.routing').then(
        (m) => m.PROPERTY_ROUTES
      ),
  },
  {
    path: 'new-projects',
    canActivate: [adminAuthGuard],
    loadChildren: () =>
      import('./components/new-projects/new-projects.routing').then(
        (m) => m.NEW_PROJECTS_ROUTES,
      ),
  },
  {
    path: 'leads',
    canActivate: [adminAuthGuard],
    loadChildren: () =>
      import('./components/leads/leads.routing').then((m) => m.LEADS_ROUTES),
  },
  {
    path: 'users',
    canActivate: [adminAuthGuard],
    loadChildren: () =>
      import('./components/users/users.routing').then((m) => m.USERS_ROUTES),
  },
  {
    path: 'campaigns',
    canActivate: [adminAuthGuard],
    loadComponent: () =>
      import('./components/campaigns/email-campaigns.component').then((m) => m.EmailCampaignsComponent),
  },
  {
    path: 'profile',
    canActivate: [adminAuthGuard],
    component: AdminProfileComponent,
  },
  {
    path: 'cities/all',
    canActivate: [adminAuthGuard],
    component: AllCitiesComponent,
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
